import { render, staticRenderFns } from "./SoliAddress.vue?vue&type=template&id=9be18c6e"
import script from "./SoliAddress.vue?vue&type=script&lang=js"
export * from "./SoliAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports